


















































































// TODO: Enable lint.
/* eslint-disable */
import { defineComponent } from '@vue/composition-api';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

export default defineComponent({
  name: "ConceptCompare03",
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/concept/compare01.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" },
    ]
  }
});
